import React, { useEffect, useState } from 'react'
import { Dialog, IconButton, Box, Button } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Close, Download } from '@mui/icons-material'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import { BlockBlobClient } from '@azure/storage-blob'

type ImageModalProps = {
	itemId: number | undefined
	padding?: number
	iconSize?: string
	imageUrlService: (requestId: number) => Promise<string[]>
}

const ImageModal = ({ itemId, padding, iconSize, imageUrlService }: ImageModalProps) => {
	const [open, setOpen] = useState(false)
	const [currentIndex, setCurrentIndex] = useState(0)
	const [imageUrls, setImageUrls] = useState<{ original: string; thumbnail: string }[]>([])

	const handleOpen = (index: number) => {
		setOpen(true)
	}

	const handleClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault()
		e.stopPropagation()
		setOpen(false)
	}
	useEffect(() => {
		if (!open || !itemId) return
		;(async () => {
			const urls = await imageUrlService(itemId)
			setImageUrls(urls.map((url) => ({ original: url, thumbnail: url })))
		})()
	}, [open])

	async function downloadImage(imageSrc: string) {
		const blockBlobClient = new BlockBlobClient(imageSrc)
		const downloadResponse = await blockBlobClient.download()
		const blob = await downloadResponse.blobBody
		const blobUrl = URL.createObjectURL(blob!)
		const link = document.createElement('a')
		link.href = blobUrl
		link.target = '_blank'
		link.download = `image-${currentIndex + 1}.jpeg` // Name file uniquely
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		URL.revokeObjectURL(blobUrl)
	}

	return (
		<div>
			<IconButton
				onClick={(e) => {
					e.preventDefault()
					e.stopPropagation()
					handleOpen(0)
				}}
				sx={{ p: padding }}
			>
				<OpenInNewIcon sx={{ color: '#007BFF', fontSize: iconSize }} />
			</IconButton>

			<Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
				<Box
					sx={{
						position: 'relative',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						bgcolor: 'black',
					}}
					onClick={(e) => e.stopPropagation()}
				>
					{/* Close Button */}
					<IconButton
						onClick={handleClose}
						sx={{
							position: 'absolute',
							top: 10,
							right: 10,
							color: 'white',
							backgroundColor: 'rgba(0,0,0,0.5)',
							zIndex: 1000,
						}}
					>
						<Close />
					</IconButton>

					<Box 
						onClick={(e) => e.stopPropagation()}
						sx={{ width: '100%' }}
					>
						<ImageGallery
							items={imageUrls}
							showThumbnails={true}
							showPlayButton={false}
							showFullscreenButton={true}
							showNav={true}
							onSlide={setCurrentIndex}
							renderCustomControls={() => (
								<>
									<Button
										variant='contained'
										startIcon={<Download />}
										onClick={async () => downloadImage(imageUrls[currentIndex].original)}
										sx={{
											position: 'absolute',
											top: 10,
											right: 60,
											backgroundColor: 'rgba(0, 0, 0, 0.5)',
											color: 'white',
											'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
											zIndex: 999,
										}}
									>
										Download
									</Button>
								</>
							)}
						/>
					</Box>
				</Box>
			</Dialog>
		</div>
	)
}

export default ImageModal
